import RiskScoreChart from './RiskScoreChart'

export default RiskScoreChart
